import {Component} from '@angular/core';

@Component({
  selector: 'playback-node',
  templateUrl: './playback-node.component.html'
})
export class PlaybackNodeComponent {
    node
}
